import { render, staticRenderFns } from "./old-retailer-invoice.vue?vue&type=template&id=147eafac"
import script from "./old-retailer-invoice.vue?vue&type=script&lang=js"
export * from "./old-retailer-invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports